
function AdminHeader() {
  
  return (
    <div className="header">
      <div className='title'>[ADMIN] Address Plant</div>
    </div>
  );
}


export default AdminHeader;
